import { Injectable, EventEmitter } from '@angular/core';
import { Settings } from './settings';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private inactivityTimeout = Settings.getInstance().InactivityTimeoutMinutes * 60 * 1000; //  in milliseconds
  private activityMonitor: any;
  inactivityTimeoutEvent: EventEmitter<void> = new EventEmitter<void>();

  startMonitoring() {
    // Reset the timer on user activity
    window.addEventListener('mousemove', () => this.resetTimer());
    window.addEventListener('keydown', () => this.resetTimer());

    this.activityMonitor = setTimeout(() => {
      console.log('User inactive. Logging out...');
      // this.inactivityTimeoutEvent.emit();
      // TODO: Perform logout or other actions here
    }, this.inactivityTimeout);

    console.log('Inactivity monitoring started.');
  }

  resetTimer() {
    if (this.activityMonitor) {
      clearTimeout(this.activityMonitor);
    }

    this.activityMonitor = setTimeout(() => {
      console.log('User inactive. Logging out...');
      // this.inactivityTimeoutEvent.emit();
      // TODO: Perform logout or other actions here
    }, this.inactivityTimeout);
  }
}
